module.exports = __webpack_public_path__ + "static/media/i2sysbio_logo3.2413504d.png";